import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { inject } from '@angular/core';

export const superAdminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);

  if (authService.isSuperAdmin()) {
    return true;
  } else {
    const router = inject(Router);
    router.navigate(['auth/login']);
    return false;
  }
};
